import { BaseConnector } from './baseConnector';

class HearingStatusConnector extends BaseConnector {
  getHearingStatuses() {
    var url = `${this.baseApiUrl}/hearingStatus`;
    return this.authFetch(url);
  }
}

export { HearingStatusConnector };
